import React from 'react';
import { motion } from 'framer-motion';
import { portfolioData } from '../data/mock';

const Header = () => {
  const { identity } = portfolioData;
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };
  
  const navItems = [
    { label: 'About', id: 'about' },
    { label: 'Stack', id: 'stack' },
    { label: 'Hobbies', id: 'hobbies' },
    { label: 'Inspired', id: 'inspired' },
    { label: 'Contact', id: 'contact' }
  ];
  
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-20 px-4 sm:px-6 py-3 sm:py-4 nav-glass"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          className="flex items-center gap-2 sm:gap-3 cursor-pointer"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <motion.img
            whileHover={{ rotate: 360 }}
            transition={{ duration: 0.6 }}
            src="https://customer-assets.emergentagent.com/job_9473450d-8fdf-465d-8892-552dd8ecfad1/artifacts/hz3lxj60_image.png"
            alt="Symbol"
            className="w-6 h-6 sm:w-8 sm:h-8 opacity-70 hover:opacity-100 transition-opacity duration-300"
          />
          <span
            className="text-xs tracking-widest hidden sm:block"
            style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(180, 195, 220, 0.8)', letterSpacing: '0.2em' }}
          >
            {identity.alias}
          </span>
        </motion.div>
        
        <nav className="flex items-center gap-3 sm:gap-5 md:gap-8">
          {navItems.map((item) => (
            <motion.button
              key={item.id}
              whileHover={{ y: -2, scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => scrollToSection(item.id)}
              className="text-xs tracking-wide nav-link"
              style={{ fontFamily: 'DM Mono, monospace', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              {item.label}
            </motion.button>
          ))}
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
